export default {
  inspirations: 'Inspirationen',
  gifts: 'Geschenke',
  occasions: 'Anlässe',
  'tutorials-and-advices': 'Tutorials und Tipps',
  'home-furnishing': 'Wohndeko',
  highlights: 'Highlights',
}
